module.exports = __webpack_public_path__ + "static/media/twitter.0857e8a2.svg";